var UrlType;
(function (UrlType) {
    UrlType[UrlType["CustomLink"] = 0] = "CustomLink";
    UrlType[UrlType["CMSPage"] = 1] = "CMSPage";
    UrlType[UrlType["Category"] = 2] = "Category";
    UrlType[UrlType["Product"] = 3] = "Product";
})(UrlType || (UrlType = {}));

export { UrlType as U };
//# sourceMappingURL=menu-0TyOg98i.js.map
